import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AuthService from "../services/AuthService";
import ApiService from "../services/ApiService";
import { CiSearch } from "react-icons/ci";
import { MdHomeFilled,  MdOutlineArrowDropDown } from "react-icons/md";
import { FcGoogle } from "react-icons/fc";
import { signInWithPopup } from "firebase/auth";
import { auth, googleProvider } from "../firebase";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  // const basePath = process.env.REACT_APP_BASE_PATH;
  const searchParams = new URLSearchParams(window.location.search);
  const goto = searchParams.get('goto') || '';
  localStorage.clear();

  const handleGoogleLogin = async () => {
    setIsLoading(true);
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      
      const googleData = {
        name: user.displayName,
        email: user.email,
        googleId: user.uid,
        phone: user.phoneNumber || "",
      };

      const response = await AuthService.googleLogin(googleData);

      if (response.status) {
        const { user: apiUser, auth_token, phone_verified, address_added } = response.data;
        if(!phone_verified) {
          navigate("/verify-phone?user_id="+apiUser._id);
          return;
        }
        // if(!address_added) {
        //   navigate("/address-list?goto="+goto);
        //   return;
        // }
        apiUser.auth_token = auth_token;
        AuthService.setCurrentUser(apiUser);
        toast.success("Login successful!");
        navigate("/address-list?goto="+goto);
      } else {
        toast.error(response.message || "Google Login failed");
      }

    } catch (error) {
      console.error("Google Login error:", error);
      toast.error(error.message || "An error occurred during Google login");
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await ApiService.request({
        method: "POST",
        url: "/login",
        data: { email, password },
      });

      if (response.data.status) {
        const { user, auth_token , phone_verified, address_added } = response.data.data;
        if(!phone_verified) {
          navigate("/verify-phone?user_id="+user._id);
          return;
        }
        // if(!address_added) {
        //   navigate("/address-list?goto="+goto);
        //   return;
        // }
        user.auth_token = auth_token;
        AuthService.setCurrentUser(user);
        toast.success("Login successful!");
        navigate("/address-list?goto="+goto);

        // const basePath = process.env.REACT_APP_BASE_PATH;
        // window.location.href=basePath+"/address-list"+goto;
      } else {
        toast.error(response.data.message || "Login failed");
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("An error occurred during login");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="header-banner bg-gradient" id="home">
      <div className="container">
        <div className="row">
          <div
            className="col-md-12 shadow main-heading"
            style={{ display: "flex", flexDirection: "column" }}
          >
            {/* Reused Header */}
            <div className="top-bar d-flex justify-content-between px-4 py-2">
              <div className="top-bar-left">
                <span className="text-secondary">Welcome</span>
                <p className="mb-0 text-base">Login to continue</p>
              </div>

              <div className="top-bar-right d-flex align-items-center">
                <Link  to="/">
                        <MdHomeFilled  className="top-bar-search-icon fs-2 mx-2 fw-semibold text-secondary"  />
                </Link>
                <Link to="/search">
                    <CiSearch className="top-bar-search-icon fs-2 text-secondary" />
                </Link>
              </div>
            </div>

            {/* Login Form */}
            <div className="row">
                <div className="tab col-md-6 col-12 my-5 mx-auto  bg-white rounded border shadow p-4">
                    <h2 className="text-center mb-4">Login</h2>
                    
                    <form onSubmit={handleLogin}>
                        <div className="mb-3">
                        <label htmlFor="email" className="form-label required">
                            Email Address
                        </label>
                        <input
                            type="email"
                            placeholder="Enter Email Address"
                            className="form-control"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        </div>

                        <div className="mb-3">
                        <label htmlFor="password" className="form-label required">
                            Password
                        </label>
                        <input
                            type="password"
                            placeholder="Enter Password"
                            className="form-control"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        </div>

                        <div className="mb-3 d-flex justify-content-between align-items-center">
                        <div className="form-check">
                            <input
                            type="checkbox"
                            className="form-check-input"
                            id="rememberMe"
                            />
                            <label className="form-check-label" htmlFor="rememberMe">
                            Remember me
                            </label>
                        </div>

                        <Link to="/forgot-password" className="text-base">
                            Forgot Password?
                        </Link>
                        </div>

                        <button
                            type="submit"
                            className="btn btn-base w-100 py-2 mb-3"
                            disabled={isLoading}
                        >
                        {isLoading ? "Logging in..." : "Login"}
                        </button>

                        <button
                            type="button"
                            className="btn btn-light w-100 py-2 mb-3 border d-flex align-items-center justify-content-center gap-2"
                            onClick={handleGoogleLogin}
                            disabled={isLoading}
                        >
                            <FcGoogle size={20} /> Sign in with Google
                        </button>

                        <div className="text-center">
                        <p>
                            Don't have an account?{" "}
                            <Link to="/register" className="text-base">
                            Register here
                            </Link>
                        </p>
                        </div>
                    </form>
                </div>

            </div>
            

          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;